import apiClient from './apiClient';
import { API_URL } from '../config';

export interface UserRecord {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  is_active: boolean;
  must_change_password: boolean;
  locale: string;
  organization_id: number | null;
  created_at: string | null;
  updated_at: string | null;
  last_login: string | null;
}

export interface CreateUserPayload {
  username: string;
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role: string;
  must_change_password?: boolean;
  organization_id?: number;
}

export interface UpdateUserPayload {
  email?: string;
  first_name?: string;
  last_name?: string;
  role?: string;
  is_active?: boolean;
  locale?: string;
}

const listUsers = async (): Promise<UserRecord[]> => {
  const resp = await apiClient.get(`${API_URL}/users`);
  return resp.data;
};

const createUser = async (payload: CreateUserPayload): Promise<UserRecord> => {
  const resp = await apiClient.post(`${API_URL}/users`, payload);
  return resp.data;
};

const updateUser = async (id: number, payload: UpdateUserPayload): Promise<UserRecord> => {
  const resp = await apiClient.put(`${API_URL}/users/${id}`, payload);
  return resp.data;
};

const deleteUser = async (id: number): Promise<{ message: string }> => {
  const resp = await apiClient.delete(`${API_URL}/users/${id}`);
  return resp.data;
};

const resetPassword = async (id: number, newPassword: string): Promise<{ message: string }> => {
  const resp = await apiClient.post(
    `${API_URL}/users/${id}/reset-password`,
    { new_password: newPassword },
  );
  return resp.data;
};

const changePassword = async (currentPassword: string, newPassword: string): Promise<{ message: string }> => {
  const resp = await apiClient.post(
    `${API_URL}/users/change-password`,
    { current_password: currentPassword, new_password: newPassword },
  );
  return resp.data;
};

const userService = {
  listUsers,
  createUser,
  updateUser,
  deleteUser,
  resetPassword,
  changePassword,
};

export default userService;
